import React from 'react';
import { Dropdown, DropdownItemProps, DropdownProps } from 'semantic-ui-react';
import FormbuilderFieldWrapper from '../../../../formBuilderAnswersComponents/formbuilderFieldWrapper';

interface DropdownFieldProps {
  label?: string;
  value?: DropdownProps['value'];
  update: (value: DropdownProps['value']) => void;
  fieldName: string;
  options?: DropdownItemProps[];
  systemOnly?: boolean;
}

const DropdownField = ({
  label,
  value,
  update,
  fieldName,
  options,
  systemOnly
}: DropdownFieldProps) => {
  return (
    <FormbuilderFieldWrapper
      label={label}
      systemOnly={systemOnly}
      value={value}
    >
      <Dropdown
        value={value}
        onChange={(_event, data) => {
          update(data.value);
        }}
        options={options}
        selection
        placeholder="Select..."
        icon="chevron down"
        id={`${fieldName}Id`}
      />
    </FormbuilderFieldWrapper>
  );
};

export default DropdownField;
